function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M62.3333 64.6V57.5167C63.8208 56.6383 64.6992 54.995 64.6 53.2667C64.6 50.7592 63.0842 48.7333 61.2 48.7333C59.3158 48.7333 57.8 50.7592 57.8 53.2667C57.7008 54.995 58.5792 56.6383 60.0667 57.5167V64.6H52.1333V30.1608L45.3333 26.7608V32.8667H48.7333V35.1333H45.3333V39.6667H48.7333V41.9333H45.3333V46.4667H48.7333V48.7333H45.3333V53.2667H48.7333V55.5333H45.3333V60.0667H48.7333V62.3333H45.3333V64.6H43.0667V18.9833L29.4667 15.1017V19.2667H37.4V21.5333H29.4667V26.0667H37.4V28.3333H29.4667V32.8667H37.4V35.1333H29.4667V39.6667H37.4V41.9333H29.4667V46.4667H37.4V48.7333H29.4667V53.2667H37.4V55.5333H29.4667V60.0667H37.4V62.3333H29.4667V64.6H27.2V1.13333H6.8V5.66666H17V7.93333H6.8V12.4667H17V14.7333H6.8V19.2667H17V21.5333H6.8V26.0667H17V28.3333H6.8V32.8667H17V35.1333H6.8V39.6667H17V41.9333H6.8V46.4667H17V48.7333H6.8V53.2667H17V55.5333H6.8V60.0667H17V62.3333H6.8V64.6H0V66.8667H68V64.6H62.3333Z",
  fill: "url(#paint0_linear_105_13)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_105_13",
  x1: 0,
  y1: 34,
  x2: 68,
  y2: 34,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1A77C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00B6DE"
})));

var SvgBuilding = function SvgBuilding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuilding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/building.fdd4fc33.svg";
export { ForwardRef as ReactComponent };